<template>
  <ContainerScrolling class="ArticleComments" @show-more="onShowMore">
    <v-div id="ArticleDetailsComments" border-softened-bottom mt-5 pb-3 mb-1>
      <h2 class="title">Comments</h2>
    </v-div>
    <v-div border-softened-bottom-thin>
      <AddComment @postComment="postArticleComment" />
    </v-div>
    <v-div v-if="!isLoggedIn" mt-2 font-smaller font-weight-light>
      <v-div d-inline-block>
        This site is protected by reCAPTCHA and the Google
        <a
          :href="`${googlePoliciesUrl}/privacy`"
          target="_blank"
          rel="noopener"
        >
          Privacy Policy
          <OpenInNewTabIcon :size="14" />
        </a>
        and
        <a :href="`${googlePoliciesUrl}/terms`" target="_blank" rel="noopener">
          Terms of Service
          <OpenInNewTabIcon :size="14" />
        </a>
        apply.
      </v-div>
    </v-div>
    <ContainerGrid>
      <Comment
        v-for="comment in comments"
        :key="comment.number"
        :comment="comment"
        :article="article"
        :recaptcha-site-key="recaptchaSiteKey"
      />
    </ContainerGrid>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";
import {
  displayIsMobile,
  displayIsTablet,
} from "~/components/utilities/displayBreakpoints";

import unauthorizedRedirect from "~/components/utilities/unauthorizedRedirect";
import ContainerScrolling, {
  isAtBottomOfWindow,
} from "~/components/layout/ContainerScrolling.vue";
import ContainerGrid from "~/components/layout/ContainerGrid";
import AddComment from "~/components/comments/AddComment.vue";
import Comment from "~/components/comments/Comment.vue";
import isLoggedIn from "~/plugins/utilities/isLoggedIn";
import OpenInNewTabIcon from "~/components/OpenInNewTabIcon.vue";

export default {
  name: "ArticleComments",
  components: {
    ContainerGrid,
    AddComment,
    Comment,
    ContainerScrolling,
    OpenInNewTabIcon,
  },
  props: {
    article: { type: Object, required: true },
    recaptchaSiteKey: { type: String, required: true },
  },
  data() {
    return {
      gettingMoreSubmitted: false,
      googlePoliciesUrl: "https://policies.google.com",
    };
  },
  head() {
    return {
      script: [
        {
          src: "https://www.recaptcha.net/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit",
          defer: true,
        },
      ],
    };
  },
  computed: {
    displayIsMobile,
    displayIsTablet,
    ...mapState({
      user: (state) => state.user,
    }),
    comments() {
      return this.article.latestComments;
    },
    displayedCommentsCount() {
      return this.article.latestComments.length;
    },
    commentsCount() {
      return this.article.commentsCount;
    },
    isLoggedIn() {
      return isLoggedIn(this.user);
    },
  },
  watch: {
    active() {
      if (isAtBottomOfWindow() === true || this.comments.length === 0) {
        this.onShowMore();
      }
    },
  },
  methods: {
    postArticleComment(content) {
      this.$store.dispatch("postArticleComment", {
        content,
        articleId: this.article.id,
        partner: this.article.origin,
      });
    },

    async onShowMore() {
      if (this.gettingMoreSubmitted === true) {
        return;
      } else if (this.displayedCommentsCount === this.commentsCount) {
        return;
      }

      this.gettingMoreSubmitted = true;

      const params = {
        entityId: this.article.id,
        createdBefore: this.comments[0]?.createdAt,
        skip: this.comments.length - 1,
        limit: 10,
      };

      try {
        await this.$store.dispatch("loadMoreComments", { params });

        this.gettingMoreSubmitted = false;
      } catch (error) {
        unauthorizedRedirect(
          this.$router.replace,
          this.$isServer,
          this.$config
        );
      }
    },
  },
};
</script>
